<template>
  <div class="container">
    <div class="box">
      <div class="title-box" :style="{ backgroundColor: '#ffac44' }">
        <h3>{{ title }} <br> {{ title2 }}</h3>
      </div>
      <!-- <div class="content-box" :style="{ backgroundColor: '#40acfc' }">
        <p>{{ content }}</p>
      </div> -->
    </div>
  </div>
</template>

<script>
export default {
    props: {
        title: String,
        title2: String,
        content: String,
        titleColor: String,
        contentColor: String
    }
};
</script>

<style scoped>
.container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.box {
  flex: 1;
  margin-right: 20px;
}

.title-box {
  padding: 10px;
  text-align: center;
  font-weight: bold;
  color: white;
  border-radius: 20px;
  white-space: normal; /* Permitir el ajuste en múltiples líneas */
  word-wrap: break-word; /* Forzar ajuste de palabras largas */
  display: flex;
  align-items: center;
  justify-content: center;
}

.content-box {
  margin-top: 20px;
  padding: 20px;
  border-radius: 10px;
  color: black;
  flex: 1; 
  min-height: 320px; 
}
@media (max-width: 768px) {
    .box{
        align-items: center;
        justify-content: center;
        align-self: center;
        display: flex;
        flex-direction: column;
        margin-right: 0;
    }
    .title-box {
        font-family: "CircularBold";
        width: 90%;
        align-self: center;
        font-size: 20px;
    }

    .content-box {
        font-family: "CircularMedium";
        width: 90%;
        min-height: 120px; 
        font-size: 18px;
    }
}
</style>
